import { render, staticRenderFns } from "./CompanyDesktopReservedWorkers.vue?vue&type=template&id=11e2ca5a"
import script from "./CompanyDesktopReservedWorkers.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopReservedWorkers.vue?vue&type=script&lang=js"
import style0 from "./CompanyDesktopReservedWorkers.vue?vue&type=style&index=0&id=11e2ca5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports